export const user = (state = {}, action) => {
  switch (action.type) {
    case "INIT":
      return { ...action.payload };
    case "UpdateAvatar":
      return { ...state, img: action.payload };
    case "UPDATE_USER_TOKEN":
      return { ...state, user_token: action.payload };
    default:
      return state;
  }
};
